import { AutoComplete, Input } from 'antd';
import _ from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { FETCH_SUB_GEO } from '../../../shared/constants/commonConstants';
import { LocationOption } from '../../../shared/models/hospitalProfile.model';
import SendRequest from '../../../shared/services/sendRequest.service';

const LocationAutoComplete = ({ onLocationSelect, cityId, location, city }: any): ReactElement => {
  const [locations, setLocations] = useState([] as any[]);
  const [value, setValue] = useState(location);

  useEffect((): void => {
    if (cityId) {
      fetchAllLocation();
      setValue('');
      setLocations([]);
    } else if (location) {
      setLocations([]);
    } else {
      setLocations([]);
      setValue('');
    }
    // eslint-disable-next-line
  }, [cityId, city]);

  const fetchAllLocation = async (): Promise<void> => {
    const request: any = {
      id: cityId,
      lookUpLevel: 1,
    };
    const locationResponse: any = await SendRequest.instance.post(process.env.REACT_APP_BASE_URL + FETCH_SUB_GEO, request);
    if (locationResponse && locationResponse.isSuccess && locationResponse.keywordLookupDetails
      && locationResponse.keywordLookupDetails.length) {
      setLocations(_.uniqBy(locationResponse.keywordLookupDetails.map((loc: LocationOption): LocationOption => {
        return { id: loc.id, value: loc.name };
      }), 'value'));
    }
  };

  const onLocationFilter = (inputValue: string, option: any): boolean =>
    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

  const onSelect = (e: string): void => {
    const [selectedLocation] = locations.filter((item: any): boolean => item.value === e);
    onLocationSelect(selectedLocation);
  };

  const onFocus = (event: any): void => {
    if (event.target.autocomplete) {
      event.target.autocomplete = 'autocomplete';
    }
  };

  const onLocationChange = (e: any): any => {
    setValue(e);
    if (e === '' || !e) {
      onLocationSelect(null);
    }
  };

  return (
    <AutoComplete value={value}
      onChange={onLocationChange}
      disabled={!cityId}
      filterOption={onLocationFilter} options={locations} placeholder="Location" onSelect={onSelect}>
      <Input autoComplete="off" onFocus={onFocus} />
    </AutoComplete>
  );
};

export default LocationAutoComplete;
